class CgProductInfo extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.mobileQuery = window.matchMedia('(max-width: 749px)');
    this.desktopUI = this.createInterface(this.querySelector('.cg-product-info__desktop'));
    this.mobileUI = this.createInterface(this.querySelector('.cg-product-info__mobile'));
    this.handleViewportChange = () => this.syncViewportState();
    this.mobileQuery.addEventListener('change', this.handleViewportChange);
    this.syncViewportState();
  }

  disconnectedCallback() {
    this.mobileQuery?.removeEventListener('change', this.handleViewportChange);
  }

  createInterface(root) {
    const ui = {
      tabs: [...(root?.querySelectorAll('[role="tab"]') || [])],
      panels: [...(root?.querySelectorAll('[role="tabpanel"]') || [])],
    };
    ui.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.selectTab(ui, tab));
      tab.addEventListener('keydown', (event) => this.handleKeydown(ui, event));
    });
    return ui;
  }

  syncViewportState() {
    if (this.mobileQuery.matches) {
      this.closeAll(this.mobileUI);
      return;
    }
    const selected = this.desktopUI.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.desktopUI.tabs[0];
    if (selected) this.openTab(this.desktopUI, selected);
  }

  closeAll(ui) {
    ui.tabs.forEach((tab, index) => {
      tab.setAttribute('aria-selected', 'false');
      tab.setAttribute('aria-expanded', 'false');
      tab.tabIndex = index === 0 ? 0 : -1;
    });
    ui.panels.forEach((panel) => { panel.hidden = true; });
  }

  openTab(ui, selectedTab) {
    ui.tabs.forEach((tab) => {
      const selected = tab === selectedTab;
      tab.setAttribute('aria-selected', String(selected));
      tab.setAttribute('aria-expanded', String(selected));
      tab.tabIndex = selected ? 0 : -1;
    });
    ui.panels.forEach((panel) => {
      panel.hidden = panel.id !== selectedTab.getAttribute('aria-controls');
    });
  }

  selectTab(ui, selectedTab, moveFocus = false) {
    const isActive = selectedTab.getAttribute('aria-selected') === 'true';
    if (ui === this.mobileUI && isActive) this.closeAll(ui);
    else this.openTab(ui, selectedTab);
    if (moveFocus) selectedTab.focus();
  }

  handleKeydown(ui, event) {
    const index = ui.tabs.indexOf(event.currentTarget);
    let next;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % ui.tabs.length;
    if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + ui.tabs.length) % ui.tabs.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = ui.tabs.length - 1;
    if (next === undefined) return;
    event.preventDefault();
    if (ui === this.mobileUI) {
      ui.tabs[next].tabIndex = 0;
      event.currentTarget.tabIndex = -1;
      ui.tabs[next].focus();
    } else {
      this.selectTab(ui, ui.tabs[next], true);
    }
  }
}

if (!customElements.get('cg-product-info')) customElements.define('cg-product-info', CgProductInfo);
